import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import TariffTypeMaintenanceCont from "presentation/view/container/TariffType/TariffTypeContMain";

CommonEntrypoint(<TariffTypeMaintenanceCont/>)